export default __webpack_public_path__ + "static/media/42.04e9253d.jpg";